import { render, staticRenderFns } from "./RewardDisplayState.vue?vue&type=template&id=081a1eac&scoped=true"
import script from "./RewardDisplayState.vue?vue&type=script&lang=js"
export * from "./RewardDisplayState.vue?vue&type=script&lang=js"
import style0 from "./RewardDisplayState.vue?vue&type=style&index=0&id=081a1eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a1eac",
  null
  
)

export default component.exports